import { booleanAttribute, ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

import { AddressField } from '../../../customer/model/address-field.model';
import { CommunicationField } from '../../../customer/model/communication-field.model';
import { CustomerContact } from '../../../customer/model/customer-information.model';
import { lensProxy } from '../../../utils/lensProxy/lensProxy';
import { ProfileEditCommunicationComponent } from '../profile-edit-communication/profile-edit-communication.component';
import { SmartAddressContainer } from '../smart-address/smart-address.container';

/**
 * This component is required to transform two levels deep fields into signals using the "lensProxy" function.
 * The lensProxy function does only address top-level fields of a signal.
 * As we are required to access deeper levels, like the "Address" field in a customer data signal,
 * this component acts as a separate layer which once more converts fields into WriteabeSignals.
 */
@Component({
  selector: 'cdf-profile-edit-contact',
  imports: [ProfileEditCommunicationComponent, SmartAddressContainer],
  template: `
    <cdf-profile-edit-communication
      [(contact)]="contact"
      [isPrimaryContactData]="isPrimaryContactData()"
      [invalidCommunicationFields]="invalidCommunicationFields()"
      [disabled]="disabled()"
      [editingEmailDisabled]="editingEmailDisabled()"
    />
    <cdf-smart-address-container
      [(address)]="contactProxy.address"
      [isPrimaryContactData]="isPrimaryContactData()"
      [invalidAddressFields]="invalidAddressFields()"
      [disabled]="disabled()"
      [validationSkipped]="validationSkipped()"
      (skipAddressValidation)="skipAddressValidation.emit()"
    />
  `,
  styleUrl: './profile-edit-contact.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileEditContactComponent {
  readonly contact = model.required<CustomerContact>();

  readonly isPrimaryContactData = input(false, { transform: booleanAttribute });
  readonly disabled = input<boolean>(false);
  readonly invalidAddressFields = input<AddressField[]>([]);
  readonly invalidCommunicationFields = input<CommunicationField[]>([]);
  readonly editingEmailDisabled = input(false);
  readonly validationSkipped = input<boolean>(false);
  readonly skipAddressValidation = output<void>();

  readonly contactProxy = lensProxy(this.contact);
}
